import { Injectable } from '@angular/core';
import { APIService } from 'src/app/api';
import { SiteGet } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-sites-api-client';


@Injectable({
    providedIn: 'root',
})
export class SitesService {
    constructor(private apiService: APIService) {
    }

  getSites(userId: string | undefined): Promise<SiteGet[]> {
    return this.apiService.getKiaSitesApiClient().getSites(userId);
  }

  getRelatedSites(siteId: string | undefined): Promise<SiteGet[]> {
    return this.apiService.getKiaSitesApiClient().getRelatedSitesSiteId(siteId);
  }

  getSitesByAccessKey(accessKey: string): Promise<SiteGet[]> {
    return this.apiService.getKiaSitesApiClient().getSitesByAccessKey(accessKey);
  }

  switchSite(userId: string, countryId: string): Promise<void> {
    return this.apiService.getKiaSitesApiClient().postSwichSite(userId, countryId);
  }
}
